import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  DataStateChangeEventArgs,
  GridComponent,
  PageSettingsModel,
  QueryCellInfoEventArgs,
  RowSelectEventArgs,
} from "@syncfusion/ej2-angular-grids";
import { timeStamp } from "console";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { EmployeeService } from "../employee/employee.service";
import { columnWidth } from "../list/list.model";
import {
  AuthorizationReturnBO,
  functionpermission,
  GetTransactionBO,
  saveTransActionBO,
  WhereCondition,
} from "./transaction-menu-modal";
import { TransactionDataMenuService } from "./transaction-menu.dataservice";
import { TransactionMenuService } from "./transaction-menu.service";
import { BulkT2025UpdateBO } from "../evvtimesheet/evvtimesheet.model";

@Component({
  selector: "app-transaction-menu",
  templateUrl: "./transaction-menu.component.html",
  styleUrls: ["./transaction-menu.component.scss"],
})
export class TransactionMenuComponent implements OnInit {
  showTable: boolean = false;
  totalRemainingAmount: number;
  InsufficientBalance: number = 0;
  private onDestroy$: Subject<void> = new Subject<void>();
  public gridTransactions: Observable<DataStateChangeEventArgs>;
  ClientDropdown: any = [];
  TranscaData: any = [];
  clientId: string = null;
  ClientId: string = "00000000-0000-0000-0000-000000000000";
  transActionId: string = "00000000-0000-0000-0000-000000000000";
  ///////////Modal Initialization/////////////////////////
  getTransactions: GetTransactionBO = new GetTransactionBO();
  saveTransAction: saveTransActionBO = new saveTransActionBO();
  modalType: string;
  payer: string;
  tranactionId: string;
  authShow: boolean = false;
  /////////////// Grid Initializations////////////////
  public transcMenuFilterettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild("grid") public grid: GridComponent;
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  start: string;
  end: string;
  filterStartDateTimesheet: any;
  filterEndDateTimesheet: any;
  arraycol: any = [];
  ColumnArray: columnWidth[];
  public filterSettings: object;
  public formatOptions: object;
  public formatOptions1: object;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    //disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true,
  };
  transactionForm: FormGroup;
  IsButtonDisable: boolean = false;
  public booleanFilter: Object = { type: 'boolean' };
  private DecimalColumns: string[] = ["TOTALAMOUNT", "EXCEEDAMOUNT", "BALANCEAMOUNT"];
  isExportedData: any = ["True", "False"];
  height: string = '220px'
  constructor(
    private httpService: TransactionMenuService,
    public toasterService: ToastrService,
    private fb: FormBuilder,
    public global: GlobalComponent,
    public generalservice: GeneralService,
    private changeDetector: ChangeDetectorRef,
    @Inject(TransactionDataMenuService)
    public getHttp: TransactionDataMenuService,
    public datePipe: DatePipe,
    private employeeService: EmployeeService,
    public dateService: DateService
  ) {
    this.gridTransactions = getHttp;
    this.transactionForm = fb.group({
      client: [" ", Validators.required],
      transactionDate: [" ", Validators.required],
      totalAmount: [" ", Validators.required],
      payor: [" ", Validators.required],
      serviceCode: ["", Validators.required],
    });

    this.saveTransAction.transactionDate =
      this.saveTransAction.transactionDate != null &&
      this.saveTransAction.transactionDate != "" &&
      this.saveTransAction.transactionDate != undefined
        ? new Date(
            new Date(this.saveTransAction.transactionDate).toDateString() +
              " " +
              "00:00:00" +
              " " +
              "GMT"
          )
            .toISOString()
            .replace("Z", "")
        : null;
  }
fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000")
     {
      return;
    }


    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    
    this.filterSettings = {
      type: "Menu",
    };

    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    this.formatOptions1 = { type: "date", format: "MM/dd/yyyy" };

    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[5],
      pageSizes: this.pageSizes,
    };
    this.GetClientDropdown();
this.GetAllClientDropDown();
this.ApplyFilter();
    this.getTransActionsData();
    this.getServiceList();
    this.getpermission();
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "TRANSACTIONS");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  ngAfterContentChecked() {
    //  this.saveTransAction.transactionDate = (this.saveTransAction.transactionDate != null && this.saveTransAction.transactionDate != undefined && this.saveTransAction.transactionDate != '') ? this.saveTransAction.transactionDate : null;
    this.changeDetector.detectChanges();
  }

  resetForm() {
    this.transactionForm.reset();
  }

 

  // .........................................dataChangeMenus.....................................................//
  public dataChangeTransactions(M): void {
    let val = M.action.requestType.toString();
    
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.getTransactions.orderColumn = M.sorted[0].name;
        this.getTransactions.orderType =
          M.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.getTransactions.value = M.action.currentFilterObject.value;
      this.getTransactions.field = M.action.currentFilterObject.field;
      this.getTransactions.matchCase = M.action.currentFilterObject.matchCase;
      this.getTransactions.operator = M.action.currentFilterObject.operator;
      if (this.getTransactions.type == "number") {
        this.getTransactions.value =(this.getTransactions.value != null && this.getTransactions.value != undefined)
          ?M.action.currentFilterObject.value.toString(): null;
        // this.getTransactions.field = M.action.currentFilterObject.field;
      }
    }
    if((val == "filtering" && M.action.action == "clearFilter") || (this.getTransactions.type != 'string' && (this.getTransactions.value == "" 
      || this.getTransactions.value == undefined || this.getTransactions.value == null))){
        this.getTransactions.field = "client";
        this.getTransactions.matchCase = false;
        this.getTransactions.operator = "startswith";
        this.getTransactions.orderColumn = "client"
        this.getTransactions.value = "";
        this.getTransactions.type = "string";
      }
    this.getTransActionsData();

    if (val == "paging" && M.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }

  /// .........................................onActionMenus.....................................................//
  public onActionTransactions(L) {
    this.getTransactions.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.getTransactions.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (L.name == "actionBegin" && L.requestType == "filterbeforeopen") {
      this.getTransactions.type = L.columnType;
    }
  }

  showTransactionColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  //////////////////////////Date Picker Date Change///////////////////////////////////////////////////////////////////////
  FromDateFilter:any
  EndDateFilter:any;
  newdates(event, type, name) {
    this.saveTransAction.payor = this.saveTransAction.serviceCode = this.saveTransAction.clientAuthorizationId = "";

    if (type == "inputchage") {
      if (name == "importdate") {
        let val = this.dateService.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let val1 = this.dateService.inputFeildchangeReturnall(event);
          this.saveTransAction.transactionDate = val1;
        }
      }
      if (name == 'FilterFromDate') {
        let val = this.dateService.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateService.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateService.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateService.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
    }
    if (type == "datechagned") {
      if (name == "importdate") {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateService.Datechange(event);
          this.saveTransAction.transactionDate = val1;
        }
      }
      if (name == 'FilterFromDate') {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let element = this.dateService.Datechange(event);
          this.FromDateFilter = element;

        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let element = this.dateService.Datechange(event);
          this.EndDateFilter = element;
        }
      }
    }
  }




 //...............................................ApplyFilter....................................................
  ApplyFilter() {
    if (this.FromDateFilter == null || this.FromDateFilter == '' || this.FromDateFilter == undefined) {
      this.toasterService.error("select start date");
      return;
    }
    else if (this.EndDateFilter == null || this.EndDateFilter == undefined || this.EndDateFilter == '') {
      this.toasterService.error("select end date");
      return;
    }
    else if ((this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '')
      && (this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '')) {
      if (new Date(this.FromDateFilter).getTime() > new Date(this.EndDateFilter).getTime()) {
        this.toasterService.error("End date should greater than start date");
        return;
      }
    }
    this.getTransactions.startDate = this.global.getDateTimeString(this.FromDateFilter)
    this.getTransactions.endDate = this.global.getDateTimeString(this.EndDateFilter)
    this.getTransActionsData();
  }

  AllClientDropDownList:any=[]
  GetAllClientDropDown() {
    this.httpService.GetAllClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllClientDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }





  refresh() {
    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.getTransactions.startDate = this.global.getDateTimeString(this.FromDateFilter)
    this.getTransactions.endDate = this.global.getDateTimeString(this.EndDateFilter)
    this.getTransactions.clientId = null
    this.getTransactions.serviceId = null
    // this.gridTimesheet.clearFiltering();
    this.getTransActionsData();
  }

  ///////////////////////////////// Get TransActions ///////////////////////////

  //......................................GetClientDropdown........................................
  GetClientDropdown() {
    this.httpService
      .GetClientDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.ClientDropdown = JSON.parse(JSON.stringify(data));
      });
  }

  clearFields() {
    this.saveTransAction.clientId = "";
    this.saveTransAction.payor = "";
    this.saveTransAction.clientAuthorizationId = "";
    this.saveTransAction.serviceCode = "";
    ///this.saveTransAction.totalAmount = 0;
    this.saveTransAction.transactionDate = "";
    this.TranscaData = [];
    setTimeout(() => {
      this.clearTotal();
    }, 400)
  }

  clearTotal(){
  
     // this.saveTransAction.totalAmount = 0;

  }

  CreateorUpdateList(type: string) {
    if (type == "new") {
      this.modalType = "new";
      this.showTable = true;
      this.resetForm();
      this.TranscaData = [];
      this.saveTransAction = new saveTransActionBO();
    } else {
      this.modalType = "edit";
      this.showTable = false;
    }

    if (this.showTable == true) {
      this.transactionForm.get("client").enable();
      // this.transactionForm.get("transactionDate").enable();
      this.transactionForm.get("payor").disable();
      this.transactionForm.get("serviceCode").disable();
    } else {
      this.transactionForm.get("client").disable();
      // this.transactionForm.get("transactionDate").disable();
      this.transactionForm.get("payor").disable();
      this.transactionForm.get("serviceCode").disable();
    }
  }

  gridTransAction: any = [];
  getAuthorizationTable() {
    if (
      this.saveTransAction.clientId == null ||
      this.saveTransAction.clientId == undefined ||
      this.saveTransAction.clientId == "" ||
      this.saveTransAction.transactionDate == null ||
      this.saveTransAction.transactionDate == undefined ||
      this.saveTransAction.transactionDate == ""
    ) {
      return;
    }
    let date = this.saveTransAction.transactionDate;
    date =
      date != null && date != undefined && date != ""
        ? this.global.getDateTimeString(date)
        : null;
    let param = new URLSearchParams();
    param.append("ClientId", this.saveTransAction.clientId);
    param.append("TransacDate", date);
    this.httpService
      .getAuth(param)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.TranscaData = JSON.parse(JSON.stringify(data));
        this.gridTransAction = data;
      });
  }

  ExceddAmoutCheck() {
    if (this.InsufficientBalance == 0) {
      if (this.saveTransAction.totalAmount > this.totalRemainingAmount) {
        this.InsufficientBalance++;
        document.getElementById("MinimumAmount").click();
      } 
      else {
        this.IsButtonDisable = true;
        this.saveOrUpdateTransaction();
      }
     
    }
    else {
      this.IsButtonDisable = true;
      this.saveOrUpdateTransaction();
    }
  }

  ///////////////////////////////////////////////// Save Transaction ///////////////////////////////////////////////////

  saveOrUpdateTransaction() {
    this.IsButtonDisable = true;
    let saveData: saveTransActionBO = JSON.parse(
      JSON.stringify(this.saveTransAction)
    );

    
    if (this.modalType == "new") {
      saveData.id = "00000000-0000-0000-0000-000000000000";
    } else {
      saveData.id = this.saveTransAction.id;
    }

    saveData.clientId = this.saveTransAction.clientId;
    saveData.id = this.saveTransAction.id;
    saveData.serviceId = this.saveTransAction.serviceId;
    saveData.transactionDate =
      this.saveTransAction.transactionDate != null &&
      this.saveTransAction.transactionDate != "" &&
      this.saveTransAction.transactionDate != undefined
        ? new Date(
            new Date(this.saveTransAction.transactionDate).toDateString() +
              " " +
              "00:00:00" +
              " " +
              "GMT"
          )
            .toISOString()
            .replace("Z", "")
        : null;
        saveData.totalAmount = parseFloat(this.saveTransAction.totalAmount.toFixed(2))
    this.httpService
      .SaveTransactions(saveData)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.IsButtonDisable = false;
          if (data) {
            if (saveData.id == "00000000-0000-0000-0000-000000000000") {
              this.toasterService.success("Transaction saved successfully!");
              document.getElementById("exampleModalSave").click();
              this.resetForm();
              setTimeout(() => {
                this.toasterService.clear();
              }, 1000);
            } else if (this.modalType == "edit") {
              this.toasterService.success("Transaction updated successfully!");
              document.getElementById("exampleModalSave").click();
              setTimeout(() => {
                this.toasterService.clear();
              }, 1000);
            }
          }
          this.getTransActionsData();
        },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toasterService.error(err, "Error"), 8000;
          }
        }
      );
  }

  /////////////////////////////////////////////////////////////////////////////////
  getauthoraization(val) {
  
    this.saveTransAction.payor = val.payorName;
    this.saveTransAction.clientAuthorizationId = val.clientAuthorizatonId;
    this.saveTransAction.serviceCode = val.serviceCode;
    this.saveTransAction.serviceId=val.serviceId;
    this.totalRemainingAmount = val.remainingAmount;
  }

  //....................................rowSelected........................................................
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.saveTransAction.payor = rowList.payorName;
    this.saveTransAction.clientAuthorizationId = rowList.clientAuthorizatonId;
    this.saveTransAction.serviceCode = rowList.serviceCode;
    this.totalRemainingAmount = rowList.remainingAmount;
  }

  //////////////////////////////////////////////////////////////////
  getTransActionsData() {
    if(this.DecimalColumns.includes(this.getTransactions.field.toUpperCase())){
      this.getTransactions.value = this.getTransactions.value + '';
      this.getTransactions.type = "decimal";
    }
    this.getHttp.executeTransactionMenu(this.getTransactions);
    let count = 0;
    this.gridTransactions
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        count = count + 1;
      });
  }
  ////////////////////////////////////////////////////////////////////////

  deleteTransaction() {
    this.IsButtonDisable = true;
    this.httpService
      .DeleteListTransac(this.saveTransAction.id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.IsButtonDisable = false;
          this.toasterService.success("Transaction Deleted successfully!");
          document.getElementById("closeLovModal").click();
          this.getTransActionsData();
        },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toasterService.error(err, "Error"), 8000;
          }
        }
      );
  }

  selectTransactiondetails(saveBos: saveTransActionBO) {
    let abc = JSON.parse(JSON.stringify(saveBos));

    this.saveTransAction = abc;
    this.saveTransAction.transactionDate = this.datePipe.transform(
      this.saveTransAction.transactionDate,
      "MM/dd/yyyy"
    );
    this.saveTransAction.totalAmount=abc.totalAmount;
    console.log(this.saveTransAction.totalAmount,"totalamounttttttt");
    this.getAuthorizationTable();

    // this.transactionForm.patchValue(saveBos);
    setTimeout(() => {
      this.getDetails(saveBos);
    }, 200);
  }


  getDetails(data){
    this.saveTransAction=JSON.parse(JSON.stringify(data));
    this.saveTransAction.id=data.id;
    this.saveTransAction.transactionDate = this.datePipe.transform(
      this.saveTransAction.transactionDate,
      "MM/dd/yyyy"
    );
        
  }

  exceedSave() {
    document.getElementById("MinimumAmount").click();
  }

  cancelValidation() {
    this.IsButtonDisable = false;
    this.InsufficientBalance = 0;
  }


  serviceList:any=[]
  getServiceList() {
    
    this.httpService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList=data
     

    })
  }
  

  exportCsv() {
    this.httpService.exportcsv(this.getTransactions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    let contentType = 'text/csv';
    const blob = this.b64toBlob(data.fileContents, contentType);
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = "Transaction Export";
    a.click();
   
    },
    (err: HttpErrorResponse) => {
      this.toasterService.error(
        err.error

      );
    })

  }

   b64toBlob = (b64Data, contentType:any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  bulkUpdateService;
  bulkUpdateAuthId;
  bulkServiceId;
  //....................................rowSelected........................................................
  rowSelectedForBulkVisitUpdate(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.bulkUpdateService = rowList.serviceCodeName;
    this.bulkServiceId = rowList.serviceId;
    this.bulkUpdateAuthId = rowList.id;

  }
  UpdateAuthorizationList: any = [];
  public UpdateAuthorizationinitialPage: PageSettingsModel;
  IsBulkUpdate: boolean = false;
  saveErr:any;
  getBulkUpdateActiveAuths() {
    this.UpdateAuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: 10, pageSizes: [10, 15, 20, 25] };
    let params = new URLSearchParams();
    params.append("clientId", this.getTransactions.clientId);
    params.append("fromDate", this.global.getDateTimeString(this.FromDateFilter));
    params.append("toDate", this.global.getDateTimeString(this.EndDateFilter));
    params.append("authType", "TRANSACTIONS");
    this.httpService.getAcitveAuths(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UpdateAuthorizationList = data;
      this.IsBulkUpdate = true;
    })
  }
  errorList:any[] = [];
  transactionsBulkUpdateBO:BulkT2025UpdateBO =new BulkT2025UpdateBO()
  updatebulktransactions() {
    this.IsBulkUpdate = false;
    this.IsButtonDisable = true;
   
    this.transactionsBulkUpdateBO.clientId = this.getTransactions.clientId;
    this.transactionsBulkUpdateBO.serviceId = this.getTransactions.serviceId;
    this.transactionsBulkUpdateBO.updateServiceId = this.bulkServiceId;
    this.transactionsBulkUpdateBO.updateAuthId = this.bulkUpdateAuthId;
    this.transactionsBulkUpdateBO.startDate = this.global.getDateTimeString(this.FromDateFilter);
    this.transactionsBulkUpdateBO.endDate = this.global.getDateTimeString(this.EndDateFilter);

      this.httpService.updateMulitpleTransactions(this.transactionsBulkUpdateBO).pipe(takeUntil(this.onDestroy$)).
      subscribe((data: any) => {
        this.IsButtonDisable = false;
       
        if (data.length == 0) {   
          this.toasterService.success('Timesheets Updated Successfully!');
          this.getTransActionsData();
          document.getElementById("updateauth").click();   
         
        } else {  
          this.errorList = data;
          if(this.errorList?.length > 0) {
            document.getElementById("errorpopup").click();   
          }
        }
      },
        (err) => {
          this.IsButtonDisable = false;
          this.toasterService.error(err, 'error');
          setTimeout(() => {
            this.saveErr = ""
          }, 8000);
        }
      );
  }

  closeBulkUpdate() {
    this.IsBulkUpdate = false;
  }

  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'balanceAmount') {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add('mark');
      }
    }
  }


}

